import useRouteQueryParams from "../../../../../common/hooks/use-route-query-params";
import OrderOptimizerListingRouteQueryParams from "../../../common/routes/types/order-optimizer-listing-route-params";
import OrderOptimizerCargoListingFilter from "../common/types/order-optimizer-cargo-listing-filter";
import orderOptimizerCargoListingFiltersService from "./order-optimizer-cargo-listing-filters.service";

const useOrderOptimizerCargoListingFiltersDao = () => {
  const [routeQueryParams, setRouteQueryParams] =
    useRouteQueryParams<OrderOptimizerListingRouteQueryParams>();

  const getPage = () => {
    return orderOptimizerCargoListingFiltersService.getPage(routeQueryParams);
  };

  const getPageSize = () => {
    return orderOptimizerCargoListingFiltersService.getPageSize(
      routeQueryParams
    );
  };

  const getFilters = (): OrderOptimizerCargoListingFilter[] => {
    return orderOptimizerCargoListingFiltersService.getFilters(
      routeQueryParams
    );
  };

  const saveFilters = (
    filters: OrderOptimizerCargoListingFilter[],
    page: number,
    pageSize: number
  ): void => {
    const routeQueryParams =
      orderOptimizerCargoListingFiltersService.createRouteQueryParams(
        filters,
        page,
        pageSize
      );

    setRouteQueryParams(routeQueryParams);
  };

  return {
    getPage,
    getPageSize,
    getFilters,
    saveFilters,
  };
};

export default useOrderOptimizerCargoListingFiltersDao;
